@let branding = brandingService.branding$ | async;

@if (branding !== null && branding !== undefined) {
    @if (isLearnerMissing) {
        <mm-profile-learner-missing></mm-profile-learner-missing>
    } @else {
        <mm-study-progress
            [changDetectionAfterTurn]="true"
            [darkMode]="(teamsContextService.teamsContext$ | async)?.app.theme === 'dark'"
            [studyProgressesData]="studyProgresses$"
            (learnPackageActivated)="learnPackage($event)">
        </mm-study-progress>
    }
}
